import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import legalAssociationsInternationalAndDomesticTerrorismAssociationItemValidator from './validators/items';
import { LegalAssociationsInternationalAndDomesticTerrorismAssociationModel } from './types';

const legalAssociationsInternationalAndDomesticTerrorismAssociationValidator: ValidateJSModel<LegalAssociationsInternationalAndDomesticTerrorismAssociationModel> = {
  HasInternationalAndDomesticTerrorismAssociation: { presence: true, hasValue: { validator: hasYesOrNo } },

  List: (value, attributes) => {
    if (attributes?.HasInternationalAndDomesticTerrorismAssociation?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: legalAssociationsInternationalAndDomesticTerrorismAssociationItemValidator },
      };
    }

    return {};
  },
};

export default legalAssociationsInternationalAndDomesticTerrorismAssociationValidator;
